module.exports = __webpack_public_path__ + "media/images/pic/labels/a1_1-226cc2fb7a823e99d1f4237923ef4d90.png";